// TODO: Delete this FF after Regula verification is fully rolled out
export const isRegulaEnabled = () => process.env.REACT_APP_USE_REGULA_VERIFICATION === 'true';

export const isSsoEnabled = () => process.env.REACT_APP_DISABLE_SSO !== 'true';

export const isChinaRegion = () => process.env.REACT_APP_REGION === 'CHINA';

export const isRSScreenDetectionEnabled = () =>
  process.env.REACT_APP_ENABLE_ROOM_SCAN_SCREEN_DETECTION === 'true';

export const isSingleNameEnabled = () => process.env.REACT_APP_ENABLE_SINGLE_NAME === 'true';
